import React, {useEffect, useState} from "react";
import Modal2 from "../Modal/Modal2";
import Step1 from "./Step1";
import Step2 from "./Step2";
import {Steps, message} from "antd";
import Loader from "../Loader";
import Success from "./Success";
import {useSelector} from "react-redux";
import restService from "../../../services/restService";
import {useToasts} from "react-toast-notifications";
import RestService from "../../../services/rest-service";
import {parsePhoneNumber} from "react-phone-number-input";
import regions from "../../../assets/static_json/regions.json";

const keys = [
  "firstname",
  "lastname",
  "email",
  "calling_code",
  "msisdn",
  "country_id",
  "address",
  "agent_role",
];
const AddNewAgency = ({show, refetchData, setShow}) => {
  const {addToast} = useToasts();

  const user = useSelector((state) => state.auth?.user);
  const [agencyAdded, setAgencyAdded] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    calling_code: "",
    msisdn: "",
    country_id: "",
    address: "",
  });
  const [agency, setAgency] = useState({});
  const [countries, setCountries] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState(0);
  const validateForm = () => {
    const keys = Object.keys(form);
    let errorList = {...errors};
    keys.forEach((key) => {
      // TODO validate phone numbers

      if (!form[key]) {
        errorList[key] = "This field is required.";
      } else {
        if (key === "email") {
          const regex = /\S+@\S+\.\S+/;
          if (!regex.test(form[key])) {
            errorList[key] = "Enter a valid email.";
          }
        }
      }
    });
    setErrors(errorList);
    return Object.keys(errorList).length === 0;
  };

  const onFormChange = ({target}) => {
    let details = {...form};
    details[target.name] = target.value;
    let errorList = errors;
    delete errorList[target.name];
    setErrors(errorList);

    if (target.name === "country_id") {
      const country = countries.filter((c) => c.id == target.value)[0];
      details.calling_code = country?.calling_code;
    }
    setForm(details);
  };

  const next = () => {
    // if (validateForm()) {
    setCurrent(current + 1);
    // }
  };

  const prev = () => {
    setCurrent(current - 1);
  };
  const handleSubmit = () => {
    //Api request to save agency
    if (validateForm()) {
      setLoading(true);
      let data = {...form};
      restService.AgencyApi.addAgency(data)
        .then(({data}) => {
          addToast("Successfully Added Agency", {
            appearance: "success",
            autoDismiss: true,
            autoDismissTimeout: 2000,
          });
          setAgency(data?.data);
          setLoading(false);
          next();
        })
        .catch(({response}) => {
          addToast(response?.data?.message, {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  useEffect(() => {
    RestService.getCountries().then(({data}) => {
      setCountries(data?.data);
      setForm({
        ...form,
        calling_code: data?.data.filter((country) => {
          return country.name === user.country?.name;
        })[0].calling_code,
        country_id: data?.data.filter((country) => {
          return country.name === user.country?.name;
        })[0].id,
      });
    });
  }, []);

  const onPhoneNumberChange = (value) => {
    const calling_code = parsePhoneNumber(String(value));
    // let msisdn = value ? value?.trim()?.slice(calling_code?.length + 1) : "";
    // const country = countries.filter(
    //   (c) => c.iso_3166_2 == calling_code?.country
    // )[0];

    setForm({
      ...form,
      calling_code: calling_code?.countryCallingCode ?? "",
      msisdn: value,
    });
  };

  const [step, setStep] = useState(1);
  const handlePrev = () => {
    if (step !== 1) {
      setStep(step - 1);
    }
  };
  const handleNext = (validate) => {
    if (step === 1) {
      if (validate()) {
        setStep(step + 1);
      }
    }
    return;
  };

  const steps = [
    {
      title: "",
      content: (
        <Step1
          countries={countries}
          errors={errors}
          setForm={setForm}
          onPhoneNumberChange={onPhoneNumberChange}
          onFormChange={onFormChange}
          form={form}
          next={handleSubmit}
          prev={prev}
        />
      ),
    },
    {
      title: "",
      content: (
        <Step2
          setCurrent={setCurrent}
          handlePrev={handlePrev}
          handleNext={handleNext}
          setAgencyAdded={setAgencyAdded}
          agency={agency}
          setLoading={setLoading}
        />
      ),
    },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  return (
    <>
      {loading ? <Loader /> : null}
      <Modal2
        onHide={() => {
          // if (agencyAdded) {
          //   setShow(false);
          // }

          setShow(false);
          setCurrent(0);
        }}
        size={agencyAdded ? "small" : "lg"}
      >
        {loading ? (
          ""
        ) : (
          <>
            {agencyAdded ? (
              <div className="h-[50vh] intro-y flex items-center justify-center">
                <Success />
              </div>
            ) : (
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 min-h-[70vh]">
                {/* Modern Header */}
                <div className="bg-white border-b border-gray-100 px-8 py-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                      <button
                        className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                        onClick={() => {
                          if (current === 0) {
                            setShow(false);
                            return;
                          }
                          if (step === 2) {
                            handlePrev();
                            return;
                          }
                          prev();
                          setShow(false);
                        }}
                      >
                        <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                      </button>
                      <div>
                        <h1 className="text-2xl font-bold text-gray-900">Add New Agency</h1>
                        <p className="text-sm text-gray-500">Create a new agency in the system</p>
                      </div>
                    </div>
                    <button
                      onClick={() => setShow(false)}
                      className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                    >
                      <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  {/* Modern Progress Steps */}
                  <div className="mt-8">
                    <div className="flex items-center justify-center max-w-md mx-auto">
                      <div className="flex items-center w-full">
                        <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300 ${
                          current >= 0 ? 'bg-green-600 border-green-600 text-white' : 'bg-white border-gray-300 text-gray-400'
                        }`}>
                          {current > 0 ? (
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          ) : (
                            <span className="text-sm font-semibold">1</span>
                          )}
                        </div>
                        <div className={`flex-1 h-1 mx-4 rounded-full transition-all duration-300 ${
                          current >= 1 ? 'bg-green-600' : 'bg-gray-200'
                        }`}></div>
                        <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300 ${
                          current >= 1 ? 'bg-green-600 border-green-600 text-white' : 'bg-white border-gray-300 text-gray-400'
                        }`}>
                          <span className="text-sm font-semibold">2</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-between max-w-md mx-auto mt-2">
                      <span className={`text-sm font-medium transition-colors duration-300 ${
                        current >= 0 ? 'text-green-600' : 'text-gray-400'
                      }`}>Agency Details</span>
                      <span className={`text-sm font-medium transition-colors duration-300 ${
                        current >= 1 ? 'text-green-600' : 'text-gray-400'
                      }`}>Add Agent</span>
                    </div>
                  </div>
                </div>

                {/* Content Area */}
                <div className="p-8">
                  <div className="max-w-4xl mx-auto">
                    {steps[current].content}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </Modal2>
    </>
  );
};

export default AddNewAgency;
